"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useRemovePushTokens = void 0;
var tslib_1 = require("tslib");
var react_1 = require("react");
var react_redux_1 = require("react-redux");
var react_redux_2 = require("react-redux");
var getIsExistingToken_1 = require("../utilities/get/getIsExistingToken");
var createErrorAction_1 = require("../actionCreators/createErrorAction");
var dispatchUpdateUnscopeUser_1 = require("../state/dispatch/dispatchUpdateUnscopeUser");
var description = 'useRemovePushTokens';
var useRemovePushTokens = function (_a) {
    var parentDescription = _a.parentDescription, onSuccess = _a.onSuccess;
    var dispatch = (0, react_redux_1.useDispatch)();
    var useDescription = "".concat(parentDescription, " - ").concat(description, " ");
    var _b = (0, react_1.useState)(false), working = _b[0], setWorking = _b[1];
    var currentUnscopeUser = (0, react_redux_2.useSelector)(function (state) {
        return state.currentUnscopeUser;
    });
    var currentUserId = (0, react_redux_2.useSelector)(function (state) {
        return state.currentUserId;
    });
    var submitRemovePushToken = (0, react_1.useCallback)(function (_a) { return tslib_1.__awaiter(void 0, [_a], void 0, function (_b) {
        var notificationTokens, isExistingToken, newMessagingTokens;
        var token = _b.token;
        return tslib_1.__generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    setWorking(true);
                    notificationTokens = currentUnscopeUser === null || currentUnscopeUser === void 0 ? void 0 : currentUnscopeUser.notificationTokens;
                    isExistingToken = (0, getIsExistingToken_1.getIsExistingToken)({
                        unscopeUser: currentUnscopeUser || undefined,
                        findToken: token,
                    });
                    if (!(token && currentUserId && isExistingToken)) return [3 /*break*/, 2];
                    newMessagingTokens = notificationTokens === null || notificationTokens === void 0 ? void 0 : notificationTokens.filter(function (_a) {
                        var _token = _a.token;
                        return token !== _token;
                    });
                    return [4 /*yield*/, (0, dispatchUpdateUnscopeUser_1.dispatchUpdateUnscopeUser)({
                            userId: currentUserId,
                            dispatch: dispatch,
                            parentDescription: useDescription,
                            values: {
                                notificationTokens: newMessagingTokens,
                            },
                        })];
                case 1:
                    _c.sent();
                    onSuccess === null || onSuccess === void 0 ? void 0 : onSuccess();
                    return [3 /*break*/, 3];
                case 2:
                    dispatch((0, createErrorAction_1.createErrorAction)({ description: "".concat(useDescription, " - missing data") }));
                    _c.label = 3;
                case 3:
                    setWorking(false);
                    return [2 /*return*/];
            }
        });
    }); }, [onSuccess, currentUserId, dispatch, useDescription, currentUnscopeUser]);
    return { submitRemovePushToken: submitRemovePushToken, working: working };
};
exports.useRemovePushTokens = useRemovePushTokens;
